export * from './main-page/main-page.component';
export * from './marco-legal/marco-legal.component';
export * from './bloque-de-bienvenida/bloque-de-bienvenida.component';
export * from './bloque-quienes-somos/bloque-quienes-somos.component';